export class VhVariable {
    constructor() {
        // for mobile devices
        function setVariable() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        window.addEventListener('resize', () => {
            setVariable()
        });

        setVariable()
    }
}
